import React from "react";

import "./_style.scss";

const AskChuffedButton = () => (
  <div className="ask-button-container">
    <a
      className="button --secondary-outline --rounded ask-button__button"
      href="https://docs.chuffed.org"
      target="_blank"
      rel="noreferrer"
    >
      Ask Chuffed
    </a>
  </div>
);

export default AskChuffedButton;
